/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon(
    "osmanager.os_catalog_explorer",
    require("./rawicons/os_catalog_explorer.icon.svg.js")
);
IconRegistry.registerIcon(
    "osmanager.os_plan_explorer",
    require("./rawicons/os_plan_explorer.icon.svg.js")
);
IconRegistry.registerIcon("osmanager.os_catalog", require("./rawicons/os_catalog.icon.svg.js"));
IconRegistry.registerIcon("osmanager.os_plan", require("./rawicons/os_plan.icon.svg.js"));
IconRegistry.registerIcon(
    "osmanager.odm_os_platform",
    require("./rawicons/odm_os_platform.icon.svg.js")
);
IconRegistry.registerIcon(
    "osmanager.odm_os_platform_explorer",
    require("./rawicons/odm_os_platform_explorer.icon.svg.js")
);
IconRegistry.registerIcon(
    "osmanager.odm_os_platform_edit",
    require("./rawicons/odm_os_platform_edit.icon.svg.js")
);
IconRegistry.registerIcon(
    "osmanager.odm_os_platform_view",
    require("./rawicons/odm_os_platform_view_action.icon.svg.js")
);
IconRegistry.registerIcon("osmanager.iot_os_plan", require("./rawicons/iot_os_plan.icon.svg.js"));
IconRegistry.registerIcon(
    "osmanager.add_os_catalog",
    require("./rawicons/add_os_catalog.icon.svg.js")
);
IconRegistry.registerIcon("osmanager.add_os_plan", require("./rawicons/add_os_plan.icon.svg.js"));
IconRegistry.registerIcon("osmanager.add_platform", require("./rawicons/add_platform.icon.svg.js"));
IconRegistry.registerIcon("osmanager.add_images", require("./rawicons/add_images.icon.svg.js"));
IconRegistry.registerIcon(
    "osmanager.add_instructions",
    require("./rawicons/add_instructions.icon.svg.js")
);
IconRegistry.registerIcon("osmanager.find_images", require("./rawicons/find_images.icon.svg.js"));
IconRegistry.registerIcon(
    "osmanager.edit_os_catalog",
    require("./rawicons/edit_os_catalog.icon.svg.js")
);
IconRegistry.registerIcon("osmanager.edit_os_plan", require("./rawicons/edit_os_plan.icon.svg.js"));
IconRegistry.registerIcon("osmanager.run_os_plans", require("./rawicons/run_os_plans.icon.svg.js"));
IconRegistry.registerIcon(
    "osmanager.edit_os_plan_associations",
    require("./rawicons/edit_os_plan_associations.icon.svg.js")
);
IconRegistry.registerIcon(
    "osmanager.move_os_plan_associations",
    require("./rawicons/move_os_plan_associations.icon.svg.js")
);
IconRegistry.registerIcon("osmanager.reboot", require("./rawicons/reboot.icon.svg.js"));
IconRegistry.registerIcon(
    "osmanager.iot_os_plan_explorer",
    require("./rawicons/iot_os_plan_explorer.svg.js")
);
